import { useContext, useMemo } from 'react';

import { Column } from 'react-table';

import { LocalizationContext } from 'localization';
import { SettingsContext } from 'settings';
import { TNormalizedSummaryItem } from 'types';

import { formatDuration, formatMoney } from './utils';

export const useColumns = (): Array<Column<TNormalizedSummaryItem>> => {
  const {
    state: {
      settings: {
        currency: { sign: currency },
      },
    },
  } = useContext(SettingsContext);
  const { t } = useContext(LocalizationContext);

  return useMemo(
    () => [
      {
        accessor: 'workerFIO',
        Header: t('report.workShift.worker'),
        width: 208,
      },
      {
        accessor: 'counter',
        Header: t('work_shift.counter'),
        width: 190,
      },
      {
        accessor: 'duration',
        Header: t('report.workShift.duration'),
        Cell: ({ value }) => formatDuration(value, t),
        width: 150,
      },
      {
        accessor: 'proceeds',
        Header: t('money.proceeds'),
        Cell: ({ value }) => formatMoney(value, currency),
        width: 177,
      },
      {
        accessor: 'goods',
        Header: t('category.goods'),
        Cell: ({ value }) => formatMoney(value, currency),
        width: 177,
      },
      {
        accessor: 'services',
        Header: t('category.services'),
        Cell: ({ value }) => formatMoney(value, currency),
        width: 177,
      },
      {
        accessor: 'bonuses',
        Header: t('report.workShifts.bonuses'),
        Cell: ({ value }) => formatMoney(value, currency),
        width: 189,
      },
      {
        accessor: 'refunds',
        Header: t('report.workShifts.refunds'),
        Cell: ({ value }) => formatMoney(value, currency),
        width: 141,
      },
      {
        accessor: 'tips',
        Header: t('tips'),
        Cell: ({ value }) => formatMoney(value, currency),
        width: 141,
      },
    ],
    [currency, t]
  );
};
